import { LogoData } from "./Logos";

import styled from "styled-components";

const OuterContainer = styled.div`
  background-color: #fff;
  width: 100vw;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: erstoria;
  color: #253569;
  background-color: rgb(255, 254, 239);
  text-align: center;

  padding-top: 40px;

  @media (max-width: 1080px) {
    margin-top: 100px;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 120px;
  background-color: rgb(255, 254, 239);
  // background-color: red;
`;

const LogoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 20px;
  @media (max-width: 1080px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const Name = styled.h1`
  font-size: 10em;
  font-weight: 200;

  margin-left: 60px;
  margin-right: 60px;

  padding-top: 10px;

  @media (max-width: 860px) {
    margin-left: none;
    margin-right: none;
    padding-top: 10px;
  }

  @media (max-width: 700px) {
    font-size: 6em;
    padding-top: 10px;
  }

  @media (max-width: 460px) {
    font-size: 5em;
    padding-top: 10px;
  }
`;

const SubHeading = styled.h3`
  font-family: Karla;
  font-size: 2.2em;
  font-weight: 400;
  width: 60%;
  text-align: center;
  margin-bottom: 120px;

  @media (max-width: 700px) {
    font-size: 1.8em;
  }

  @media (max-width: 460px) {
    font-size: 1.6em;
  }
`;

const LogoCell = ({ url, children }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <a
        href={url}
        style={{
          textDecoration: "none",
          color: "#253569",
        }}
      >
        {children}
      </a>
    </div>
  );
};

const Landing = () => {
  return (
    <OuterContainer>
      <Name>CIANNA CANNING</Name>
      <SubHeading>
        Video Production, Documentary Filmmaking, Outreach & Communications
      </SubHeading>
      <LogoContainer>
        <LogoGrid>
          {LogoData.map((logo) => (
            <LogoCell url={logo.url} key={logo.url}>
              {logo.component}
            </LogoCell>
          ))}
        </LogoGrid>
      </LogoContainer>
    </OuterContainer>
  );
};

export default Landing;
